<script setup lang="ts">
import { Select } from '@taler/ui'
import { useI18n } from 'vue-i18n'
import { ACCOUNT_CLASSES } from '../internal/query-params.ts'

defineProps<{ modelValue: (typeof ACCOUNT_CLASSES)[number] }>()
const emit = defineEmits<{ 'update:modelValue': [value: (typeof ACCOUNT_CLASSES)[number]] }>()
const { t } = useI18n()

const options = ACCOUNT_CLASSES.map((value) => ({ value, label: value }))
</script>

<template>
  <label class="flex items-center gap-2 text-[length:var(--text-step-2)] text-[color:var(--color-text)]">
    <span class="text-[color:var(--color-text-muted)]">{{ t('reporting.accountClass') }}</span>
    <Select
      :model-value="modelValue"
      :options="options"
      @update:model-value="emit('update:modelValue', $event)"
    />
  </label>
</template>
